<template>
<div class="chapter">
<div class="inner_page">
<p class="author"><a id="page_iii"></a><strong>Raymond A. Schroth, S.J.</strong></p>
<h1 class="h1">The American Jesuits</h1>
<p class="subtitle"><em>A History</em></p>
<p class="publisher"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?10dd76d6